// extracted by mini-css-extract-plugin
module.exports = {"radio":"DiningOption__radio___3VUa1"};